export default __webpack_public_path__ + "static/media/phone.effa7c0d.svg";